<template>
  <div id="emails">
    <loading :active.sync="bigLoading" 
        :can-cancel="false"
        loader="dots"
        color="#007bff"
        :height="45"
        :width="75"
        :is-full-page="fullPage">
        </loading>
    <v-dialog v-model="showDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">{{ msg }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="indigo white--text"
            depressed
            @click="showDialog = false"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show429Dialog" max-width="500">
  <v-card>
    <v-card-title
      class="headline white--text"
      style="background-color: #c62828;"
    >
      Too Many Requests
    </v-card-title>

    <v-card-text class="pt-4 subtitle-1">
      {{ msg429 }}
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="red darken-3 white--text"
        depressed
        @click="show429Dialog = false"
      >
        Ok
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    <div class="indigo" height="30px" id="emails__header">
      <div id="emails__header--99" ref="boxcheck">
        <v-checkbox v-model="selectall" />
      </div>
      <div id="emails__header--1" @click.prevent="sortBy('muid')">
        <b
          class="bold_font"
          v-bind:class="{ activeField: activeField === 'muid' }"
          >ID</b
        >
      </div>
      <div id="emails__header--2"><b>Status</b></div>
      <div id="emails__header--3" @click.prevent="sortBy('email_subject')">
        <b
          class="bold_font"
          v-bind:class="{ activeField: activeField === 'email_subject' }"
          >Subject</b
        >
      </div>
      <div id="emails__header--5" @click.prevent="sortBy('email_from_one')">
        <b
          class="bold_font"
          v-bind:class="{ activeField: activeField === 'email_from_one' }"
          >Panelist Email</b
        >
      </div>
      <div id="emails__header--6" @click.prevent="sortBy('panelist_core')">
        <b
          class="bold_font"
          v-bind:class="{ activeField: activeField === 'panelist_core' }"
          >Flag</b
        >
      </div>
      <div id="emails__header--7" @click.prevent="sortBy('panelist_score')">
        <b
          class="bold_font"
          v-bind:class="{ activeField: activeField === 'panelist_score' }"
          >Points</b
        >
      </div>
      <div id="emails__header--9" @click.prevent="sortBy('email_read')">
        <b
          class="bold_font"
          v-bind:class="{ activeField: activeField === 'email_read' }"
          >Mark</b
        >
      </div>
      <div id="emails__header--10">
        <b class="bold_font">Attachment</b>
      </div>
      <div id="emails__header--8" @click.prevent="sortBy('email_date')">
        <b
          class="bold_font"
          v-bind:class="{ activeField: activeField === 'email_date' }"
          >Date</b
        >
      </div>
      <div id="emails__header--4"><b class="bold_font">Action</b></div>
    </div>
    <!-- <div v-if="isloading" class="loader"> -->
    <div v-if="isloading">
      <loading :active.sync="isloading" :can-cancel="false" loader="dots" color="#007bff" :height="45" :width="75"
        :is-full-page="fullPage"></loading>
    </div>
    <v-card v-else-if="emails.length > 0">
      <v-list id="emails__list">
        <v-list-item-group>
          <EmailItem
            v-for="(email, i) in emails"
            v-bind:key="email.id"
            v-bind:email="email"
            :class="emailClass(i)"
            ref="email"
          />
        </v-list-item-group>
      </v-list>
    </v-card>
    <div v-else>No Records</div>
    <v-row v-if="emails.length > 0 && !isloading">
      <v-col :cols="2" id="emails__assign">
        <v-text-field
          label="Assign Copies ID"
          outlined
          dense
          v-model="product_id"
        />
      </v-col>
      <v-col :cols="2" id="emails__assign">
        <v-btn
          color="indigo white--text"
          depressed
          @click.prevent="assignEmails()"
          >Update</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>
<script>
import _ from "lodash";
import EmailItem from "./../components/EmailsItem";
import Loading from "vue-loading-overlay";
import { mapGetters } from "vuex";
export default {
  name: "Emails",
  data() {
    return {
      orders: [
        { key: "muid", val: true },
        { key: "email_subject", val: true },
        { key: "email_from_one", val: true },
        { key: "panelist_core", val: true },
        { key: "point", val: true },
        { key: "email_date", val: true },
        { key: "panelist_score", val: true },
        { key: "email_read", val: true },
      ],
      enableSorting: false,
      showDialog: false,
      msg: "",
      fullPage:true,
      show429Dialog: false,
    msg429: "",

    };
  },
  components: {
    EmailItem,
    Loading,
  },
  mounted() {
  var view = this
  let nodes = document.querySelectorAll(".v-messages"), size = nodes.length, i = 0
  for (i = 0; i < size; i++) {
    nodes[i].style.display = 'none'
  }

  this.$refs.boxcheck.firstChild.style.marginTop = '3px'

  let dashboardType = this.$store.getters['RawData/getDashboardType'];

  if(dashboardType=='junk'){
      this.$store.dispatch("Search/setSHOWEMAILTYPEJUNK", true);
      this.$store.dispatch("Search/setSHOWEMAILTYPEBLANK", false);
      this.$store.dispatch("Search/setSHOWEMAILTYPEUNUSED", false);
      this.$store.dispatch("Search/setSHOWEMAILTYPEUSED", false);
      this.$store.dispatch("Search/setSHOWEMAILTYPECOPY", false);
  } else if(dashboardType=='focus'){
      this.$store.dispatch("Search/setSHOWEMAILTYPEJUNK", false);
      this.$store.dispatch("Search/setSHOWEMAILTYPEBLANK", true);
      this.$store.dispatch("Search/setSHOWEMAILTYPEUNUSED", true);
      this.$store.dispatch("Search/setSHOWEMAILTYPEUSED", false);
      this.$store.dispatch("Search/setSHOWEMAILTYPECOPY", false);
  }

  const runSearch = () => {
  view.$utils.search(view)
    .catch((e) => {
      if (e && e.is429) {
        view.show429Dialog = true;
        view.msg429 = e.message || "Too many requests. Please wait and try again.";
      } else {
        console.log(e);
      }
    });
};

  if (typeof this.$route.params['isFromSearch'] !== 'undefined') {
      if (this.$route.params['isFromSearch']) {
          view.$store.dispatch('Emails/setPage', 1)
          .then(() => view.$store.dispatch('Emails/setPerPage', 10))
          .then(() => view.$store.dispatch('Emails/setSortingDirection', 'desc'))
          .then(() => view.$store.dispatch('Emails/setSortingField', 'email_date'))
          .then(() => runSearch());
      } else {
          if (!this.$store.getters['Search/getIsFromSearch']) {
              view.$store.dispatch('Emails/setSortingDirection', 'desc')
              .then(() => view.$store.dispatch('Emails/setSortingField', 'email_date'))
              .then(() => runSearch());
          }
      }
  } else {
      if (!this.$store.getters['Search/getIsFromSearch']) {
          view.$store.dispatch('Emails/setSortingDirection', 'desc')
          .then(() => view.$store.dispatch('Emails/setSortingField', 'email_date'))
          .then(() => runSearch());
      }
  }

  nodes = document.querySelectorAll(".v-text-field__details"), size = nodes.length
  for (i = 0; i < size; i++) {
    nodes[i].style.display = "none"
  }
},
  computed: {
     ...mapGetters({
      bigLoading: 'RawData/getBigLoading',
    }),
    emails: function () {
      return this.allEmails();
    },
    isloading: function () {
      return this.$store.getters["Emails/getIsLoading"];
    },
    selectall: {
      get: function () {
        return this.$store.getters["Emails/getAllChecked"];
      },
      set: function (v) {
        var view = this;
        //console.log(v)
        view.$store.dispatch("Emails/setUpdateAll", v).then(function () {
          view.$refs.email.forEach(function (o) {
            o.checkThisEmail(v);
            if (view.product_id && v) {
              o.updateStatusToCopy(4);
            }
          });
        });
      },
    },
    product_id: {
      get: function () {
        return this.$store.getters["Emails/getProductId"];
      },
      set: function (n) {
        var view = this,
          o = view.$store.getters["Emails/getProductId"],
          c = n.split(o).pop(),
          regex = /[\d -]+/g;
        if (!regex.test(c)) {
          view.$store.dispatch("Emails/setProductId", "").then(function () {
            view.showDialog = true;
            view.msg = "Enter a valid Entry ID or MUID.";
            return;
          });
        } else {
          this.$store.dispatch("Emails/setProductId", n);
        }
      },
    },
    activeField: {
      get: function () {
        return this.$store.getters["Emails/getSortingField"];
      },
    },
  },
  methods: {
    checkIfCheckboxesSelected: function () {
      let updateObjects = this.$store.getters["Emails/getUpdateObjects"];
      if (Array.isArray(updateObjects) && updateObjects.length) {
        if (!confirm("Do you really want to continue with unsaved changes?")) {
          return false;
        }
      }
    },
    getPages: function () {
      var arr = new Array(),
        start = parseInt(1),
        end = parseInt(this.lastPage),
        i;
      if (parseInt(this.totPage) > parseInt(10)) {
        if (parseInt(this.currentPage) <= 4) {
          end = 9;
        } else if (parseInt(this.currentPage) == parseInt(this.lastPage)) {
          start = parseInt(this.lastPage / 10) * 10 + 1;
          end = this.lastPage;
        } else if (parseInt(this.currentPage) >= parseInt(5)) {
          start = this.currentPage - 4;
          if (parseInt(this.lastPage) - parseInt(this.currentPage) <= 4) {
            end = this.lastPage;
          } else {
            end = this.currentPage + 4;
          }
        }
      }
      for (i = start; i <= end; i++) {
        arr.push(i);
      }
      return arr;
    },
    sortBy: function (sortby) {
      this.enableSorting = true;

      let view = this,
        fields_to_sort = [
          "muid",
          "email_subject",
          "email_date",
          "email_from_one",
          "panelist_core",
          "panelist_score",
          "email_read",
        ];

      const isFieldSorted = _.find(fields_to_sort, function (o) {
        return o === sortby;
      });
      //console.log('isFieldSorted', sortby, isFieldSorted)
      let direction = this.$store.getters["Emails/getSortingDirection"];
      //let isPageFlag = false;
      if (this.activeField != sortby) {
        direction = "desc";
        //isPageFlag= true;
      } else {
        direction = direction == "asc" ? "desc" : "asc";
      }
      if (isFieldSorted != undefined) {
        view.$store
          .dispatch("Emails/setSortingDirection", direction)
          .then(function () {
            view.$store
              .dispatch("Emails/setSortingField", sortby)
              .then(function () {
                //let query = view.$store.getters['Search/getSearchQuery']
                if (!view.$store.getters["Search/getIsFromSearch"]) {
                  view.$store.dispatch("Emails/setPage", 1).then(function () {
                    view.$utils.fetchEmails(view);
                  });
                } else {
                  view.$store.dispatch("Emails/setPage", 1).then(function () {
                    view.$utils.search(view);
                  });
                }
              });
          });
      }

      /*
                const order = _.find(this.orders, function (o) {
                    return o.key === sortby;
                });
                var view = this,
                    payload = this.$store.getters['Emails/getResponsePayload'],
                    sorted = _.sortBy(payload, [function (o) {
                        return order.key === 'muid' || order.key === 'panelist_score' ? parseInt(o[order.key]) : o[order.key];
                    }]);
                view.$store.dispatch('Emails/setResponsePayload', order.val ? sorted : sorted.reverse()).then(function () {
                    view.orders.forEach(function (o) {
                        if (o.key === order.key) {
                            o.val = !o.val;
                        }
                    });
                }).catch(function (e) {
                    console.log(e)
                })*/
    },
    allEmails: function () {
      if (this.enableSorting) {
        this.enableSorting = false;
        return this.$store.getters["Emails/getResponsePayload"];
      } else {
        // if (this.$store.getters['Search/getIsFromSearch']) {
        //     return _.sortBy(this.$store.getters['Emails/getResponsePayload'], [function(o) {
        //         return parseInt(o.email_date)
        //     }]).reverse()
        // } else {
        //     return this.$store.getters['Emails/getResponsePayload']
        // }
        return this.$store.getters["Emails/getResponsePayload"];
      }
    },
    emailClass: function (i) {
      return parseInt(i) % 2 === parseInt(0)
        ? "grey lighten-2"
        : "grey lighten-5";
    },
    assignEmails: function () {
      this.$store.dispatch("RawData/setBigLoading", true);
      var view = this,
        objs = view.$store.getters["Emails/getUpdateObjects"],
        prod_id = view.$store.getters["Emails/getProductId"],
        v = view.$utils.validate(this),
        myPromise = new Promise(function (resolve, reject) {
          if (prod_id.length === 0) {
            view.showDialog = true;
            view.msg = "Product ID can not be empty.";
            view.$store.dispatch("RawData/setBigLoading", false);
            reject("Product ID can not be empty.");
          } else {
            resolve(true);
          }
        });
      myPromise
        .then(function () {
          return new Promise(function (resolve, reject) {
            if (objs.length === 0) {
              view.showDialog = true;
              view.msg = "Please choose atleast one record.";
              view.$store.dispatch("RawData/setBigLoading", false);
              reject("Please choose atleast one record.");
            } else {
              resolve(true);
            }
          });
        })
        .then(function () {
          return new Promise(function (resolve, reject) {
            if (v !== true) {
              view.showDialog = true;
              view.msg = v;
              view.$store.dispatch("RawData/setBigLoading", false);
              reject(v);
            } else {
              resolve(true);
            }
          });
        })
        .then(function () {
          view.$utils.updateEmailDetails(view, false)
          view
            .$fetch({
              url: view.$url("ASSIGN_COPY"),
              type: "POST",
              data: JSON.stringify({
                payload: objs,
                entries: view.$store.getters["Emails/getProductId"],
              }),
              contentType: "application/json",
            },{
                operation: 'add',
                vueScope: view
            })
            .then(function (response) {
              view.showDialog = true;
              view.$store.dispatch("RawData/setBigLoading", false);
              view.msg = response.msg;
              view.$store.dispatch("Emails/setProductId", "");
              //var refs = view.$store.getters["RawData/getEmailsItemRefs"];
              // if (refs.length > 0) {
              //   refs.forEach(function (o) {
              //     o.checkThisEmail(false);
              //   });
              // }
              view.$refs.email.forEach(function (o) {
                o.checkThisEmail(false);
              });
              view.$store.dispatch('Emails/removeAllUpdateObj', [])
            });
        })
        .catch((e) => console.log(e));
    },
  },
  watch:{
    // '$store.state.RawData.update_checkboxed': function(){
    //       var view = this;
    //       view.$store.dispatch("Emails/setUpdateAll", false).then(function () {
    //         view.$refs.email.forEach(function (o) {
    //           o.checkThisEmail(false);
    //           // if (view.product_id && v) {
    //           //   o.updateStatusToCopy(4);
    //           // }
    //         });
    //       });
    // },
  }
};
</script>
<style lang="sass" scoped>
@import "./../assets/sass/emails.sass"
</style>